/**
 * Stencil does not support "unknown" type for properties.
 */
export type StencilUnknown = object | string | number | boolean | null | undefined;
